import { Navigate } from "react-router";
import { Body, H1 } from "@datapay-by-datacom/design-system";
import {
  CLIENT_PAY_NORMALISATION_DISPLAY_NAME,
} from "../config";
import { useClientPayNormalisationEnabled } from "../hooks/useClientPayNormalisationEnabled";
import { ClientPayNormalisationScreen } from "../screens/ClientPayNormalisationScreen";
import s from "./ClientPayNormalisationLayout.module.css";

/**
 * Route guard + page shell for client pay-run normalisation.
 *
 * Nested inside `OnboardingLayout` (`enable-onboarding`). This layout adds the
 * per-feature gate (`enable-client-pay-normalisation`). Standalone — no company
 * context step (R-NFR-2).
 */
export function ClientPayNormalisationLayout() {
  const { isLoaded, areFlagsOn } = useClientPayNormalisationEnabled();

  if (!isLoaded) {
    return null;
  }

  if (!areFlagsOn) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className={s.container}>
      <header className={s.pageHeader}>
        <H1>{CLIENT_PAY_NORMALISATION_DISPLAY_NAME}</H1>
        <Body className={s.pageSubtitle}>
          Payslip to detail and summary CSV for the Excel variance workbook.
        </Body>
      </header>
      <ClientPayNormalisationScreen />
    </div>
  );
}
